import React, { Component } from "react";
import { HelmetProvider } from "react-helmet-async";
import TodoApp from "./components/todo/TodoApp";
import "./bootstrap.css";
import "./App.css";

class App extends Component {
  render() {
    return (
      <HelmetProvider>
        <div className="App">
          <TodoApp />
        </div>
      </HelmetProvider>
    );
  }
}

export default App;
